import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { BRAND } from "./data";

const WhatsAppButton = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShow(true), 3000);
    return () => clearTimeout(t);
  }, []);

  return (
    <a
      href={`https://wa.me/${BRAND.whatsapp.replace(/\D/g, "")}?text=${encodeURIComponent(
        "Hello House of Numbardar, I'd like to speak with an advisor."
      )}`}
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-6 right-6 z-[90] flex items-center gap-3 pl-4 pr-5 py-3 bg-[#0a8a4a] text-white shadow-[0_18px_40px_-12px_rgba(10,138,74,0.55)] transition-all duration-500 hover:bg-[#0c9d56] hover:translate-y-[-2px] ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
      data-testid="whatsapp-floating-btn"
    >
      <MessageCircle size={20} strokeWidth={1.6} />
      <span className="hidden sm:flex flex-col leading-tight">
        <span className="font-ui text-[10px] uppercase track-label opacity-80">
          Speak to the House
        </span>
        <span className="font-ui text-[12px] font-medium">
          {BRAND.phones[0]}
        </span>
      </span>
    </a>
  );
};

export default WhatsAppButton;
